import React, { useMemo, useState } from 'react';
import { hasPermission } from '@app/helpers/permissions';
import { exportaRelatorioOverView, TabelaProjetoOverViewResult } from '@app/api/tabelaProjetoOverView';
import { PaginationConfig } from 'antd/lib/pagination';
import { formatCurrencyBr } from '@app/helpers/numbers';
import { Button, FormInput, ColumnProps, Form, Row, Col, FormResetButton, Table, Widget, FormatText } from '@digital/ui';
import { Icon, Tooltip } from 'antd';
import { compareText, compareNumber } from '@app/helpers/comparators';
import StatusCircle from '@app/components/statusCircle';
import { exportarRelatorioProjetoOverFechamento } from '@app/api/fechamento';


interface TabelaProjetoOverViewProps {
    dataSourceResult: TabelaProjetoOverViewResult[] | undefined,
    telaFechamento: boolean,
    fechamentoId?: string;
}


const TabelaProjetoOverviewResumo = ({ dataSourceResult, telaFechamento, fechamentoId }: TabelaProjetoOverViewProps) => {

    const colluns = useMemo(() => {
        const col: ColumnProps<TabelaProjetoOverViewResult>[] = [
            {
                title: 'N',
                dataIndex: 'index',
                sorter: (a, b) => compareNumber(a.index, b.index),
            },
            {
                title: 'CÓD. PROJETO',
                dataIndex: 'codProjeto',
                sorter: (a, b) => compareText(a.codProjeto, b.codProjeto),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar CÓD. PROJETO"
                                name="codProjeto"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') {
                                            clearFilters(selectedKeys || []);
                                        }
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    const resultFiltro =
                        record.codProjeto !== undefined &&
                        record.codProjeto
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase());
                    return resultFiltro;
                },
            },
            {
                title: 'NOME DO PROJETO',
                dataIndex: 'nomeProjeto',
                sorter: (a, b) => compareText(a.nomeProjeto, b.nomeProjeto),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar CÓD. PROJETO"
                                name="nomeprojeto"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') {
                                            clearFilters(selectedKeys || []);
                                        }
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) => {
                    const resultFiltro =
                        record.nomeProjeto !== undefined &&
                        record.nomeProjeto
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase());

                    return resultFiltro;
                },
            },
            {
                title: 'Dir',
                dataIndex: 'diretoriaSigla',
                render: (text, row, index) => {
                    return (
                        <>
                            <Tooltip title={row.diretoriaNome}>
                                <span>{row.diretoriaSigla}</span>
                            </Tooltip>
                        </>
                    );
                },
                sorter: (a, b) => compareText(a.diretoriaSigla, b.diretoriaSigla),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar CÓD. PROJETO"
                                name="diretoria"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.diretoriaSigla !== undefined &&
                    record.diretoriaSigla
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'Área',
                dataIndex: 'areaSigla',
                render: (text, row, index) => {
                    return (
                        <>
                            <Tooltip title={row.areaNome}>
                                <span>{row.areaSigla}</span>
                            </Tooltip>
                        </>
                    );
                },
                sorter: (a, b) => compareText(a.areaSigla, b.areaSigla),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="area"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.areaSigla !== undefined &&
                    record.areaSigla
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },
            {
                title: 'Dep',
                dataIndex: 'departamentoSigla',
                render: (text, row, index) => {
                    return (
                        <>
                            <Tooltip title={row.departamentoNome}>
                                <span>{row.departamentoSigla}</span>
                            </Tooltip>
                        </>
                    );
                },
                sorter: (a, b) => compareText(a.departamentoSigla, b.departamentoSigla),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <Form>
                        <Row>
                            <FormInput
                                placeholder="Pesquisar"
                                name="departamento"
                                style={{ marginTop: '15px' }}
                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                onPressEnter={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                            />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Button
                                    type="primary"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                    icon="commons-search"
                                    size="small">
                                    Pesquisar
                                </Button>
                            </Col>
                            <Col span={6}>
                                <FormResetButton
                                    size="small"
                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                    beforeReset={() => {
                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                    }}>
                                    Limpar
                                </FormResetButton>
                            </Col>
                        </Row>
                    </Form>
                ),
                filterIcon: filtered => {
                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                },
                onFilter: (value, record) =>
                    record.departamentoSigla !== undefined &&
                    record.departamentoSigla
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()),
            },

            {

                align: 'center',
                title: 'Economic Progr (%)',
                children: [
                    {
                        title: 'Plan',
                        dataIndex: 'economicProgrPlan',
                        align: 'center',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <Tooltip title={row.descricaoEconomicProgrPlan}>
                                        <span>{row.economicProgrPlan}</span>
                                    </Tooltip>
                                </>
                            )
                        }
                    },
                    {
                        title: 'Actual',
                        dataIndex: 'economicProgrActual',
                        align: 'center',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <Tooltip title={row.descricaoEconomicProgrActual}>
                                        <span>{row.economicProgrActual}</span>
                                    </Tooltip>
                                </>
                            )
                        }
                    },
                    {
                        title: 'AdEc',
                        dataIndex: 'economicProgrAdEc',
                        align: 'center',
                        render: (text, row, index) => {
                            return (
                                <>
                                    <Tooltip title={row.descricaoEconomicProgrAdEc}>
                                        <span>{row.economicProgrAdEc}</span>
                                    </Tooltip>
                                </>
                            )
                        }
                    },
                ],
            },
            {
                align: 'center',
                title: `Completion`,
                children: [
                    {
                        title: 'Plan',
                        dataIndex: 'completionPlan',
                        align: 'center',

                    },
                    {
                        title: 'Forecast',
                        dataIndex: 'completionForecast',
                        align: 'center',
                    },
                    {
                        align: 'center',
                        render: (text, row, index) => {
                            return (row.statusCompletion != undefined ? <StatusCircle noPrazo={row.statusCompletion} valorLabel={''} /> : <> </>)
                        },
                    },
                ],
            },
            {
                align: 'center',
                title: `CapEx R$M`,
                children: [
                    {
                        title: 'Plan',
                        dataIndex: 'capExplan',
                        align: 'center',
                    },
                    {
                        title: 'Forecast',
                        dataIndex: 'capExForecast',
                        align: 'center',
                    },
                    {
                        align: 'center',
                        render: (text, row, index) => {
                            return (<StatusCircle noPrazo={row.statusCapEx} valorLabel={''} />);
                        },
                    },
                ],
            },
        ];

        if (telaFechamento === true) {
            col.push({
                title: `Detalhe`,
                align: 'center',
                render: (text, row, index) => {
                    return (
                        <>
                            <Button
                                onClick={() => {
                                    window.open(`/detalheFechamentoProjetoOverView/detalhe?fechamentoId=${fechamentoId}&projetoId=${row.id}`);
                                }}
                                icon="commons-search"
                            />
                        </>
                    );
                },
            });
        }

        return col;
    }, []);

    const btns = () => {
        if (dataSourceResult && dataSourceResult.length > 0) {
            return [
                <Button
                    type="primary"
                    name="btnExportar"
                    icon="files-ms_excel"
                    onClick={() => {
                        if (telaFechamento === false) {
                            exportaRelatorioOverView()
                        } else {
                            exportarRelatorioProjetoOverFechamento(fechamentoId, `ProjectsOverview.xlsx`)
                        }
                    }}>
                    <FormatText id="data-export" uppercase transform={() => 'Exportar Relatório'} />
                </Button>
            ]
        }
        return [];
    }

    return (
        <Widget
            actions={btns()}>
            <Table
                rowKey="id"
                id="tableProjetoOverview"
                columns={colluns}
                dataSource={dataSourceResult}
                pagination={
                    {
                        pageSize: 30,
                        onChange: () => {
                            document.getElementById('tableProjetoOverview').scrollIntoView();
                        },
                    } as PaginationConfig
                }
                onChange={(pagination, filters, sorter, extra) => {

                }}
            />
        </Widget>
    )
}


export default TabelaProjetoOverviewResumo;